import { render, staticRenderFns } from "./FadeInTransition.vue?vue&type=template&id=39dbf70b&"
import script from "./FadeInTransition.vue?vue&type=script&lang=js&"
export * from "./FadeInTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports